import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ApolloProvider, ApolloClient, createHttpLink, InMemoryCache, from } from '@apollo/client';

import PreviewReport from 'containers/Reports/PreviewReport';
import { cleanTypenameLink } from 'apolloClient';
import ExtellioConfigProvider from 'ExtellioConfigProvider';
import './app.less';
import NoMatch from 'containers/NoMatch';
import { IntlProvider } from 'react-intl';
import translations from 'translations';
import DownloadReport from './DownloadReport';

const httpLink = createHttpLink({
  uri: `${process.env.REPORT_BASE_PATH}/graphql`,
});

const client = new ApolloClient({
  link: from([cleanTypenameLink, httpLink]),
  cache: new InMemoryCache(),
});

const App = () => (
  <ExtellioConfigProvider>
    <ApolloProvider client={client}>
      <BrowserRouter basename={process.env.REPORT_BASE_PATH}>
        <Switch>
          <Route
            path="/view/:reportId/:date?"
            render={({ match }) => <PreviewReport match={match} isPrint />}
          />
          <Route
            path="/:format/:reportId/:date"
            component={DownloadReport}
          />
          <Route path="*">
            <IntlProvider locale="en-GB" key="en-GB" messages={translations['en-GB']}>
              <NoMatch />
            </IntlProvider>
          </Route>
        </Switch>
      </BrowserRouter>
    </ApolloProvider>
  </ExtellioConfigProvider>
);

export default App;
